import './subscribe.less';

export default angular.module('cian.newbuild.serp.subscribe', [])
  .directive('serpSubscribe', () => ({
    restrict: 'E',
    template: require('./subscribe.html'),
    replace: true,
    bindToController: {
      email: '@?',
      // Заголовок виджета подписки
      cardTitle: '=?',
      // Поясняющий текст
      text: '@?',
      // Тип сделки: sale / rent
      dealType: '@',
      // Название списка (будет видно в сохранённых поисках)
      searchTitle: '@',
      // Полный урл поиска (не ЧПУ, без домена): "/cat.php?..."
      url: '@',
      gaLabel: '@?'
    },
    controller: [
      '$log',
      '$scope',
      '$timeout',
      '$element',
      'ApiService',
      'AnalyticsService',
      'SerpListService',
      function ($log, $scope, $timeout, $element, ApiService, AnalyticsService, SerpListService) {
        const ctrl = this;

        ctrl.cardTitle = ctrl.cardTitle || 'Подпишитесь на новые объявления';

        ctrl.isLoading = false;
        ctrl.isSent = false;

        const successSend = res => {
          $log.debug('success', res);
          ctrl.isSent = true;

          if (ctrl.gaLabel) {
            AnalyticsService.trackCA('subscription', 'Send', ctrl.gaLabel, {
              searchConditions: SerpListService.lastQuery,
              email: ctrl.email,
            });
          }
        };

        const failSend = err => {
          $log.error(err);
          Notifications.add({
            type: 'error',
            content: 'При оформлении подписки возникла проблема. Попробуйте позже.',
            timeout: 5000
          });
        };

        ctrl.send = () => {
          if (ctrl.form.$invalid) {
            return;
          }

          ctrl.isLoading = true;

          const data = {
            email: ctrl.email,
            dealType: ctrl.dealType,
            title: ctrl.searchTitle,
            filterParams: ctrl.url,
          };

          ApiService.saveSearch(data)
            .then(successSend)
            .catch(failSend)
            .finally(() => ctrl.isLoading = false);
        };

        ctrl.isEmailInvalid = () => ctrl.form.$submitted && ctrl.form.email.$invalid;
      }],
      controllerAs: 'subscribe'
  }))
  .name;



// WEBPACK FOOTER //
// ./src/serp/directives/subscribe/subscribe.dir.js